module.exports = __webpack_public_path__ + "static/media/03.3da17b42.jpg";